const API = {
    setHeaders (headersStruct) {
        const headers = new Headers();

        Object.keys(headersStruct).forEach((headerKey) => {
            headers.append(headerKey, headersStruct[headerKey]);
        });

        return headers;
    },

    GET (endpoint) {
        return fetch(endpoint, {
            method: 'GET',
            headers: API.setHeaders({
                'X-Requested-With': 'XMLHttpRequest'
            }),
            credentials: 'include'
        }).then((response) => { return response.text(); });
    },

    POST (endpoint, data) {
        return fetch(endpoint, {
            method: 'POST',
            headers: API.setHeaders({
                'X-Requested-With': 'XMLHttpRequest'
            }),
            credentials: 'include',
            body: data
        }).then((response) => {
            if (
                response.redirected &&
                response.url.indexOf(location.origin) === 0
            ) {
                window.location.href = response.url;
            } else if (
                response.status === 202 &&
                response.url.indexOf('/join-direct/') > -1
            ) {
                return { getStripeToken: true };
            } else {
                return response.text();
            }
        });
    }
};

export default API;



// WEBPACK FOOTER //
// ./assets/js/core/API.js